module.exports = "/images/gmx.png?450ece3c69b36a35f4c440fe3d5e9b24";